import React from "react";
import {
  Modal,
  ModalClose,
  ModalOverlay,
  ModalPanel,
} from "../../components/common/Modal";
import { CrossModalDemo } from "../../components/CrossModal/Demo";
import { CrossModalFeatures } from "../../components/CrossModal/Features";
import { CrossModalLoginBanner } from "../../components/CrossModal/LoginBanner";
import { CrossModalLogo } from "../../components/CrossModal/Logo";
import { CrossModalSubtitle } from "../../components/CrossModal/Subtitle";
import { CrossModalTitle } from "../../components/CrossModal/Title";
import { GlobalNavVariation } from "../../constants/constants";
import { useCrossModalContext } from "../../hooks/useCrossModalContext";

interface CrossModalProps {
  open: boolean;
  onClose: () => void;
}

export function CrossModal({ open, onClose }: CrossModalProps) {
  const { crossModalVariation, setCrossModalVariation } =
    useCrossModalContext?.() || {};

  const [internalOpen, setInternalOpen] = React.useState(open);

  React.useEffect(() => {
    setInternalOpen(open);
  }, [open]);

  const handleClose = () => {
    setInternalOpen(false);
    onClose();
  };

  const titleBlock =
    crossModalVariation === GlobalNavVariation.WE_CARE_CONNECT ? (
      <>
        <CrossModalTitle />
        <CrossModalSubtitle className="mb-3" />
      </>
    ) : (
      <>
        <CrossModalSubtitle className="mb-3" />
        <CrossModalTitle />
      </>
    );

  React.useEffect(() => {
    const handleShowCrossModal = (event: CustomEvent) => {
      const variation = event.detail?.variation;
      if (setCrossModalVariation && variation) {
        setCrossModalVariation(variation);
      }
      setInternalOpen(true);
    };

    window.addEventListener(
      "show-cross-modal",
      handleShowCrossModal as EventListener
    );

    return () => {
      window.removeEventListener(
        "show-cross-modal",
        handleShowCrossModal as EventListener
      );
    };
  }, [setCrossModalVariation]);

  return (
    <Modal open={internalOpen} onClose={handleClose}>
      <ModalOverlay />
      <ModalPanel onClose={handleClose}>
        <ModalClose onClose={handleClose} />
        <div className="space-y-8 px-8 pb-14 pt-8 text-[15px] leading-relaxed text-gray-600 hcp:text-hcp-purple-800 ai:text-ai-blue-800 lg:px-14">
          <CrossModalLoginBanner />
          <CrossModalLogo />
          <div>{titleBlock}</div>
          <CrossModalDemo />
          <CrossModalFeatures />
        </div>
      </ModalPanel>
    </Modal>
  );
}
